import { QueryClient } from 'react-query'

/**
 * Shared react-query client. Lives in a separate module (not index.tsx) so
 * non-component code (login/logout services) can drop the cache when the
 * session changes. Query keys are user-agnostic, so without an explicit
 * clear() a previous user's responses leak into the next session within the
 * same tab — visible on shared origins like the ru-credu.ru proxy.
 */
export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			retry: 0,
			cacheTime: 30 * (60 * 1000), // 30 минут
			staleTime: 30 * (60 * 1000), // 30 минут
			refetchOnWindowFocus: false,
		},
	},
})
